module.exports = __webpack_public_path__ + "img/INFP.7d7d1fd0.png";